import { InMemoryCache, makeVar, ReactiveVar } from '@apollo/client';
import ISelectedColor from '../model/ISelectedColor';

export const selectedColorVar: ReactiveVar<ISelectedColor[]> = makeVar<ISelectedColor[]>([]);

export const selectedActiveSectionNameVar: ReactiveVar<string> = makeVar<string>('');

export const selectedCurrencyVar: ReactiveVar<string> = makeVar<string>('');
export const selectedFeaturesIdVar: ReactiveVar<string[]> = makeVar<string[]>([]);
export const searchCarIdVar: ReactiveVar<string> = makeVar<string>('');

const cache = new InMemoryCache({
  typePolicies: {
    CustomizedCarConfiguration: {
      fields: {
        selectedActiveSectionName: {
          read(): string {
            return selectedActiveSectionNameVar();
          },
        },
        selectedCurrency: {
          read(): string {
            return selectedCurrencyVar();
          },
        },
        selectedFeaturesId: {
          read(): string[] {
            return selectedFeaturesIdVar();
          },
        },
        searchCarId: {
          read(): string {
            return searchCarIdVar();
          },
        },
      },
    },
    FeatureAttributes: {
      keyFields: ['oemcode'],
    },
  },
});

export default cache;
